module.exports = __webpack_public_path__ + "img/23.0fa31006.jpg";